import React from "react";
import styles from "./styles.module.scss";

const SelectSeller = ({ selectedSellerId, setSelectedSellerId, sellers }) => {
  return (
    <div className={styles.select_seller_wrapper}>
      <select
        value={selectedSellerId}
        onChange={(e) => setSelectedSellerId(e.target.value)}
        className={styles.select_seller}
      >
        <option value="">Select Seller</option>
        {sellers.map((seller) => (
          <option key={seller.id} value={seller.id}>
            {seller.name}
          </option>
        ))}
      </select>
    </div>
  );
};

export default SelectSeller;
